<div class="prime-card" [formGroup]="consentForm">
    <div class="decorative-shape-top"></div>
    <div class="decorative-shape-back"></div>
    <img class="prime-card-glow-top" src="assets/svg/icons/glow.svg" />
    <div class="prime-card-wrapper">
        <header class="prime-card-header">
            <web-cibil-footer class="cibil-score-footer"></web-cibil-footer>
            <h3 class="header-title-gradient-center">Track your latest score and keep it growing!</h3>
        </header>
        <main class="prime-card-body">
            <div class="body-content mt-auto">
                <div class="checkbox-card prime-subcard">
                    <mat-checkbox class="checkbox-label-md-50" formControlName="isChecked">
                        I agree to the
                        <a class="link-primary-underline" href="javascript:void(0)" (click)="viewTermsAndConditions()"
                            >Terms and Conditions</a
                        >
                        of TUCIBIL and hereby provide my explicit consent to share my Credit Information with
                        <span class="text-primary"> AUREUS FINVEST PRIVATE LIMITED. </span>
                    </mat-checkbox>
                </div>
            </div>
        </main>
        <footer class="prime-card-footer">
            <div class="prime-card-footer-right">
                <button type="button" class="primary-outline-btn" [disabled]="isContinue" (click)="notNow()">
                    Not Now
                </button>
                <button
                    type="button"
                    class="primary-fill-btn"
                    [disabled]="!consentForm.get('isChecked')?.value || isContinue"
                    (click)="onContinue()"
                >
                    <span *ngIf="isContinue">Continue... <web-spinner></web-spinner> </span>
                    <span *ngIf="!isContinue">Continue</span>
                </button>
            </div>
        </footer>
    </div>
</div>
